import { createContext, useContext } from 'react';

const TaxonomyContext = createContext([]);

export const TaxonomyProvider = ({ children, groups }) => (
    <TaxonomyContext.Provider value={groups}>
        {children}
    </TaxonomyContext.Provider>
);

export const useTaxonomy = () => useContext(TaxonomyContext);

export default TaxonomyContext;